import comp from "./UnitPlanningAI";
export default comp;
